import { logger } from '@saaga/shared/utils/logger.util'
import type React from 'react'

export interface SplitViewContentDefinition<T = Record<string, unknown>> {
  type: string
  title: string
  subtitle?: (data: T) => string | undefined
  icon: React.ComponentType<{ className?: string }>
  iconClassName?: string
  component: React.FC<{ data: T; className?: string }>
  isValidData: (data: unknown) => data is T
  onTitleClick?: (data: T) => (() => void) | undefined
}

type AnyContentDefinition = SplitViewContentDefinition<Record<string, unknown>>

const registry = new Map<string, AnyContentDefinition>()

export const registerSplitViewContent = <T extends Record<string, unknown>>(
  definition: SplitViewContentDefinition<T>
): void => {
  if (registry.has(definition.type)) {
    logger.warn(`Split view content type "${definition.type}" is already registered. Overwriting.`)
  }
  registry.set(definition.type, definition as AnyContentDefinition)
}

export const getContentDefinition = (type: string | null): AnyContentDefinition | undefined => {
  if (!type) return undefined
  return registry.get(type)
}

export const getAllContentTypes = (): string[] => Array.from(registry.keys())

export const hasContentType = (type: string): boolean => registry.has(type)
